import React from 'react';
// import styles from './missing-merchant-document.module.scss';

import { MissingDocumentContainer } from 'components';
export default function MissingMerchantDocument(props) {
    return <MissingDocumentContainer {...props} />;
}
